export default __webpack_public_path__ + "static/panoramic4-4120ba8c3b096df41dfe2063235820b0.jpg";